import { createContext, useContext } from "react";

export type RootPageContextType = {
	sideMenuOpen: boolean;
	username: string | null;
	setSideMenuOpen: (open: boolean) => void;
	logout: () => void;
};

export const RootPageContext = createContext<RootPageContextType | null>(null);

export function useRootPageContext() {
	const context = useContext(RootPageContext);
	if (!context) {
		throw new Error("useRootPageContext must be used within RootPageContext.Provider");
	}
	return context;
}
